import { render, staticRenderFns } from "./_dailyWinloseTournament.vue?vue&type=template&id=b9a89c82&lang=pug&"
import script from "./_dailyWinloseTournament.vue?vue&type=script&lang=js&"
export * from "./_dailyWinloseTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports